// ============================================================================
// PLAYER PROFILE CONSTANTS
// Redux action type constants for Player Profile functionality
// ============================================================================

// Get Player Profile
export const GET_PLAYER_PROFILE_REQUEST = 'GET_PLAYER_PROFILE_REQUEST';
export const GET_PLAYER_PROFILE_SUCCESS = 'GET_PLAYER_PROFILE_SUCCESS';
export const GET_PLAYER_PROFILE_FAIL = 'GET_PLAYER_PROFILE_FAIL';
export const GET_PLAYER_PROFILE_RESET = 'GET_PLAYER_PROFILE_RESET';

// Get Player Financial Summary
export const GET_PLAYER_SUMMARY_REQUEST = 'GET_PLAYER_SUMMARY_REQUEST';
export const GET_PLAYER_SUMMARY_SUCCESS = 'GET_PLAYER_SUMMARY_SUCCESS';
export const GET_PLAYER_SUMMARY_FAIL = 'GET_PLAYER_SUMMARY_FAIL';
export const GET_PLAYER_SUMMARY_RESET = 'GET_PLAYER_SUMMARY_RESET';

// Get Player Transactions
export const GET_PLAYER_TRANSACTIONS_REQUEST = 'GET_PLAYER_TRANSACTIONS_REQUEST';
export const GET_PLAYER_TRANSACTIONS_SUCCESS = 'GET_PLAYER_TRANSACTIONS_SUCCESS';
export const GET_PLAYER_TRANSACTIONS_FAIL = 'GET_PLAYER_TRANSACTIONS_FAIL';
export const GET_PLAYER_TRANSACTIONS_RESET = 'GET_PLAYER_TRANSACTIONS_RESET';

// Get Player Analytics
export const GET_PLAYER_ANALYTICS_REQUEST = 'GET_PLAYER_ANALYTICS_REQUEST';
export const GET_PLAYER_ANALYTICS_SUCCESS = 'GET_PLAYER_ANALYTICS_SUCCESS';
export const GET_PLAYER_ANALYTICS_FAIL = 'GET_PLAYER_ANALYTICS_FAIL';
export const GET_PLAYER_ANALYTICS_RESET = 'GET_PLAYER_ANALYTICS_RESET';

// Get Player Clubs
export const GET_PLAYER_CLUBS_REQUEST = 'GET_PLAYER_CLUBS_REQUEST';
export const GET_PLAYER_CLUBS_SUCCESS = 'GET_PLAYER_CLUBS_SUCCESS';
export const GET_PLAYER_CLUBS_FAIL = 'GET_PLAYER_CLUBS_FAIL';
export const GET_PLAYER_CLUBS_RESET = 'GET_PLAYER_CLUBS_RESET';

export const GET_PLAYER_REFERRALS_REQUEST = 'GET_PLAYER_REFERRALS_REQUEST';
export const GET_PLAYER_REFERRALS_SUCCESS = 'GET_PLAYER_REFERRALS_SUCCESS';
export const GET_PLAYER_REFERRALS_FAIL = 'GET_PLAYER_REFERRALS_FAIL';
export const GET_PLAYER_REFERRALS_RESET = 'GET_PLAYER_REFERRALS_RESET';

// Freeze Player Account
export const FREEZE_PLAYER_REQUEST = 'FREEZE_PLAYER_REQUEST';
export const FREEZE_PLAYER_SUCCESS = 'FREEZE_PLAYER_SUCCESS';
export const FREEZE_PLAYER_FAIL = 'FREEZE_PLAYER_FAIL';
export const FREEZE_PLAYER_RESET = 'FREEZE_PLAYER_RESET';

// Ban Player Account
export const BAN_PLAYER_REQUEST = 'BAN_PLAYER_REQUEST';
export const BAN_PLAYER_SUCCESS = 'BAN_PLAYER_SUCCESS';
export const BAN_PLAYER_FAIL = 'BAN_PLAYER_FAIL';
export const BAN_PLAYER_RESET = 'BAN_PLAYER_RESET';

// Unban Player Account
export const UNBAN_PLAYER_REQUEST = 'UNBAN_PLAYER_REQUEST';
export const UNBAN_PLAYER_SUCCESS = 'UNBAN_PLAYER_SUCCESS';
export const UNBAN_PLAYER_FAIL = 'UNBAN_PLAYER_FAIL';
export const UNBAN_PLAYER_RESET = 'UNBAN_PLAYER_RESET';

// Get Player Full Phone (Sensitive)
export const GET_PLAYER_PHONE_REQUEST = 'GET_PLAYER_PHONE_REQUEST';
export const GET_PLAYER_PHONE_SUCCESS = 'GET_PLAYER_PHONE_SUCCESS';
export const GET_PLAYER_PHONE_FAIL = 'GET_PLAYER_PHONE_FAIL';
export const GET_PLAYER_PHONE_RESET = 'GET_PLAYER_PHONE_RESET';

export const ASSIGN_PLAYER_CLUB_REQUEST = 'ASSIGN_PLAYER_CLUB_REQUEST';
export const ASSIGN_PLAYER_CLUB_SUCCESS = 'ASSIGN_PLAYER_CLUB_SUCCESS';
export const ASSIGN_PLAYER_CLUB_FAIL = 'ASSIGN_PLAYER_CLUB_FAIL';
export const ASSIGN_PLAYER_CLUB_RESET = 'ASSIGN_PLAYER_CLUB_RESET';

export const REMOVE_PLAYER_CLUB_REQUEST = 'REMOVE_PLAYER_CLUB_REQUEST';
export const REMOVE_PLAYER_CLUB_SUCCESS = 'REMOVE_PLAYER_CLUB_SUCCESS';
export const REMOVE_PLAYER_CLUB_FAIL = 'REMOVE_PLAYER_CLUB_FAIL';
export const REMOVE_PLAYER_CLUB_RESET = 'REMOVE_PLAYER_CLUB_RESET';

// List All Players
export const LIST_PLAYERS_REQUEST = 'LIST_PLAYERS_REQUEST';
export const LIST_PLAYERS_SUCCESS = 'LIST_PLAYERS_SUCCESS';
export const LIST_PLAYERS_FAIL = 'LIST_PLAYERS_FAIL';
export const LIST_PLAYERS_RESET = 'LIST_PLAYERS_RESET';

// Get Player Remarks
export const GET_PLAYER_REMARKS_REQUEST = 'GET_PLAYER_REMARKS_REQUEST';
export const GET_PLAYER_REMARKS_SUCCESS = 'GET_PLAYER_REMARKS_SUCCESS';
export const GET_PLAYER_REMARKS_FAIL = 'GET_PLAYER_REMARKS_FAIL';
export const GET_PLAYER_REMARKS_RESET = 'GET_PLAYER_REMARKS_RESET';

// Update Player Remarks
export const UPDATE_PLAYER_REMARKS_REQUEST = 'UPDATE_PLAYER_REMARKS_REQUEST';
export const UPDATE_PLAYER_REMARKS_SUCCESS = 'UPDATE_PLAYER_REMARKS_SUCCESS';
export const UPDATE_PLAYER_REMARKS_FAIL = 'UPDATE_PLAYER_REMARKS_FAIL';
export const UPDATE_PLAYER_REMARKS_RESET = 'UPDATE_PLAYER_REMARKS_RESET';

// Delete Player
export const DELETE_PLAYER_REQUEST = 'DELETE_PLAYER_REQUEST';
export const DELETE_PLAYER_SUCCESS = 'DELETE_PLAYER_SUCCESS';
export const DELETE_PLAYER_FAIL = 'DELETE_PLAYER_FAIL';
export const DELETE_PLAYER_RESET = 'DELETE_PLAYER_RESET';

// Bulk Delete Players
export const BULK_DELETE_PLAYERS_REQUEST = 'BULK_DELETE_PLAYERS_REQUEST';
export const BULK_DELETE_PLAYERS_SUCCESS = 'BULK_DELETE_PLAYERS_SUCCESS';
export const BULK_DELETE_PLAYERS_FAIL = 'BULK_DELETE_PLAYERS_FAIL';
export const BULK_DELETE_PLAYERS_RESET = 'BULK_DELETE_PLAYERS_RESET';
